import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <Player>
            <source src="https://wiki.instar.com/videos/Portweiterleitung_bei_einer_Digitalisierungsbox_Smart.mp4" />
        </Player>
        <EuiText>
            <p>Portweiterleitung bei einer Digitalisierungsbox Smart / Premium. Auf <OutboundLink href="https://www.youtube.com/watch?v=h4k0M50Il_U" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard